import { ErrorResponse, TransferStatusEnum } from "@gtpl/shared-models/common-models";
import { CommonResponse, PlantIdRequest } from "@gtpl/shared-models/masters";
import { Injectable } from "@nestjs/common";
import appSettings from "apps/services/config";
import { AssetStatusEnum } from "libs/shared-models/common-models/src/lib/enum/asset-status.enum";
import moment from "moment";
import { AssetTransferRepository } from "./repository/asset-transfers.repository";
import { AssetTransfersAdapter } from "./dto/asset-transfers.adapter.ts";
import { AssetTransfersDto } from "./dto/asset-transfers.dto";
import { AssetTransfer } from "./entity/asset-transfer.entity";
import { UnitcodeService } from '@gtpl/shared-services/masters';
import { getManager } from "typeorm";
import { TransferIdRequest } from "./dto/transfer-id.request";
import { GenericTransactionManager } from "apps/services/backend/typeorm-transactions/generic-transaction-manager";
import { AssetsRepository } from "../open-assets/dto/opens-assets-repository";
import { AssetRequistionRepository } from "../asset-requistion/repository/asset-requisition.repository";
import { UserService} from '@gtpl/shared-services/attendance';
import { LocationByPlant } from "../locations/dto/location-by-plant.dto";
@Injectable()
export class AssetTransfersService {
    constructor(
        private assetTransferRepository: AssetTransferRepository,
        private assetAdapter: AssetTransfersAdapter,
        private unitcodeService: UnitcodeService,
        private userService : UserService

    ) { }

    async createAssetTransfers(assetTransfersDto: AssetTransfersDto): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            let flag = true;
            const savedAssetTransfers: AssetTransfer[] = [];
            let dcsCount = await this.assetTransferRepository.count({ where: { fromPlant: assetTransfersDto.assetTransfer[0].fromPlant } });
            dcsCount += 1;
            const today = new Date();
            const CurrentYear = today.getFullYear();
            const CurrentMonth = today.getMonth();

            // get form plant name 
            const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: assetTransfersDto.assetTransfer[0].fromPlant });
            const fromPlant = plantDetails.status ? plantDetails.data.unitcodeName : "";

            const toPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: assetTransfersDto.assetTransfer[0].toPlant });
            const toPlant = toPlantDetails.status ? toPlantDetails.data.unitcodeName : "";

            let refNo = dcsCount + "";
            while (refNo.length < 4) refNo = "0" + refNo;
            assetTransfersDto.dcNumber = "DC/" + fromPlant.toLocaleUpperCase() + "-" + toPlant.toLocaleUpperCase() + "/" + (CurrentYear.toString().substr(-2)) + "/" + refNo;

            const convertedAssetTransferEntity: AssetTransfer = this.assetAdapter.convertDtotoAssetTransferEntity(assetTransfersDto);
            await manager.startTransaction();
            const savedAssetTransferEntity: AssetTransfer = await this.assetTransferRepository.save(convertedAssetTransferEntity);
            savedAssetTransfers.push(savedAssetTransferEntity);
            console.log(savedAssetTransfers,'savedAssetTransfers8888888')
            const savedAssetTransferDto: AssetTransfersDto = this.assetAdapter.convertEntitytoAssetTransferDto(savedAssetTransferEntity);
            if (savedAssetTransferDto) {
                let updateStock = await manager.getCustomRepository(AssetsRepository).update({assetId:savedAssetTransferDto.assetTransfer[0].assetsId}, {status: AssetStatusEnum.INTRANSIT})
                if(!updateStock.affected){
                    flag = false;
                }
                if(flag){
                    await manager.completeTransaction();
                    const response = new CommonResponse(true, 11100, 'Asset Transfered Successfully. ', savedAssetTransferDto);
                    return response;
                }
                else{
                    await manager.releaseTransaction();
                    const response = new CommonResponse(false, 11011, 'something went wrong. ', savedAssetTransferDto);
                    return response;
                }
                
            } else {
                await manager.releaseTransaction();
                const response = new CommonResponse(false, 11011, 'something went wrong. ', savedAssetTransferDto);
                return response;
            }
        } catch (error) {
            await manager.releaseTransaction();
            return error;
        }
    }

    async getDCTransfers(req: LocationByPlant): Promise<CommonResponse> {
        try{
            const manager = getManager();
            let query = "Select isc.item_sub_category AS itemSubCategory,ucc.unit_name as plant,a.assets_code AS assetCode, asset_transfer_id AS assetTransferId,u.unit_name AS fromPlant, uc.unit_name AS toPlant,transfer_type AS transferType, transfer_date AS transferedDate,dc_number AS dcNumber,mrn_number AS mrnNumber, i.item_name AS assetName, transfered_quantity AS transferedQty,at.status As status from "+appSettings.assets_db+".asset_transfer at left join "+appSettings.assets_db+".assets a ON a.asset_id = at.asset_id left join "+appSettings.masters_db+".item_sub_categories isc on isc.item_sub_category_id = at.asset_category_id left join "+appSettings.masters_db+".unitcodes u on u.unit_code_id = at.from_plant left join "+appSettings.masters_db+".unitcodes uc on uc.unit_code_id = at.to_plant LEFT JOIN "+appSettings.masters_db+".unitcodes ucc ON ucc.unit_code_id = at.unit_id left join "+appSettings.masters_db+".items i on i.item_id = a.assets_name ";
       
            if (req.plant > 0 && req.plant != 5) {
                query = query + 'and ucc.unit_name = ' + req.plant + `order by status,from_plant`
            }
            let result = await manager.query(query);
            if(result.length > 0){
                return new CommonResponse(true,1001,"DC transfers successfully retrived. ", result);
            }
            else{
                return new CommonResponse(false,1010,"Something went wrong. ",);
            }
        }catch (error) {
            return error;
        }
    }

    async getMRNTransfers(req: PlantIdRequest): Promise<CommonResponse> {
        try{
            const manager = getManager();
            let query = "Select isc.item_sub_category AS itemSubCategory, asset_transfer_id AS assetTransferId,u.unit_name AS fromPlant, uc.unit_name AS toPlant, transfer_type AS transferType, transfer_date AS transferedDate,dc_number AS dcNumber,mrn_number AS mrnNumber, i.item_name AS assetName, transfered_quantity AS transferedQty,a.assets_code AS assetCode, at.status As status from "+appSettings.assets_db+".asset_transfer at left join "+appSettings.assets_db+".assets a ON a.asset_id = at.asset_id left join "+appSettings.masters_db+".item_sub_categories isc on isc.item_sub_category_id = at.asset_category_id left join "+appSettings.masters_db+".unitcodes u on u.unit_code_id = at.from_plant left join "+appSettings.masters_db+".unitcodes uc on uc.unit_code_id = at.to_plant left join "+appSettings.masters_db+".items i on i.item_id = a.assets_name where to_plant ="+req.unitcodeId+" order by status,to_plant";
            let result = await manager.query(query);
            if(result.length > 0){
                return new CommonResponse(true,1001,"DC transfers successfully retrived. ", result);
            }
            else{
                return new CommonResponse(false,1010,"Something went wrong. ",);
            }
        }catch (error) {
            return error;
        }
    }

    async ReceiveAsset(req: TransferIdRequest): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try{
            let flag = true;
            let checkAsset = await this.assetTransferRepository.findOne({where:{assetTransferId:req.assetTransferId}});
            if(checkAsset){
                let MRNCount = await this.assetTransferRepository.count({ where: { toPlant: checkAsset.toPlant, status: TransferStatusEnum.RECEIVED } });
                MRNCount += 1;
                const today = new Date();
                const CurrentYear = today.getFullYear();
                const CurrentMonth = today.getMonth();
                let fromDate = 0;
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear);
                } else {
                    fromDate = (CurrentYear);
                }
                //get received emp id
                const receivedEmp = await this.userService.getAllActiveUser();
                let receivedEmpId = receivedEmp.status?receivedEmp.data.find((rec) => rec.id === req.updatedUserId).employeeId:0;
                // get form plant name 
                const plantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: checkAsset.fromPlant });
                const fromPlant = plantDetails.status ? plantDetails.data.unitcodeName : "";

                const toPlantDetails = await this.unitcodeService.getPlantDetailsById({ unitcodeId: checkAsset.toPlant });
                const toPlant = toPlantDetails.status ? toPlantDetails.data.unitcodeName : "";

                let refNo = MRNCount + "";
                while (refNo.length < 4) refNo = "0" + refNo;
                const mrnNumber = "MRN/" + fromPlant.toLocaleUpperCase() + "-" + toPlant.toLocaleUpperCase() + "/" + (fromDate.toString().substr(-2)) + "/" + refNo;
                await manager.startTransaction();
                let updateAsset = await this.assetTransferRepository.update({assetTransferId:req.assetTransferId},{status:TransferStatusEnum.RECEIVED,mrnNumber:mrnNumber,receivedDate:req.receivedDate,receivedBy:receivedEmpId});
                if(updateAsset.affected > 0){
                    let updateStock;
                    let updateIndent;
                    if(checkAsset.transferType === "INTERNAL"){
                        updateStock = await manager.getCustomRepository(AssetsRepository).update({assetId:checkAsset.assetsId}, {status: AssetStatusEnum.INUSE,employeeId:req.assetTransferId})
                        if(!updateStock.affected){
                            flag = false;
                        }
                    }
                    else if(checkAsset.transferType === "EXTERNAL"){
                        updateStock = await manager.getCustomRepository(AssetsRepository).update({assetId:checkAsset.assetsId}, {status: AssetStatusEnum.INUSE,employeeId:req.assetTransferId,plant:checkAsset.toPlant});
                        if(!updateStock.affected){
                            flag = false;
                        }
                    }
                    else if(checkAsset.transferType === "INDENT"){
                        updateStock = await manager.getCustomRepository(AssetsRepository).update({assetId:checkAsset.assetsId}, {status: AssetStatusEnum.INUSE,employeeId:req.assetTransferId});
                        if(!updateStock.affected){
                            flag = false;
                        }
                        updateIndent = await manager.getCustomRepository(AssetRequistionRepository).update({requestId:checkAsset.indentId}, {status: "COMPLETED"});
                        if(!updateIndent.affected){
                            flag = false;
                        }
                    }
                    if(flag){
                        await manager.completeTransaction();
                        return new CommonResponse(true,1001,"DC transfers successfully retrived. ",);
                    }
                    else{
                        await manager.releaseTransaction();
                        return new CommonResponse(false,1010,"Something went wrong. ",);
                    }
                }
                else{
                    await manager.releaseTransaction();
                    return new CommonResponse(false,1010,"Something went wrong. ",);
                }
            }
        }catch (error) {
            await manager.releaseTransaction();
            return error;
        }
    }
    async getTransferDetails(req: TransferIdRequest): Promise<CommonResponse>{
        try{
            const manager = getManager();
            let TransferQuery = `SELECT at.asset_transfer_id AS assetTransferId ,  isc.item_sub_category AS categoryName  ,i.item_name AS itemName, at.status AS assetTransfer , at.transfer_date AS transferDate , at.received_date receivedDate ,a.asset_cost AS assetCost ,
            at.transfer_type AS transferType , at.dc_number AS dcNumber , at.mrn_number AS mrnNumber , uf.unit_name AS fromPlant , ut.unit_name AS toPlant , 
            at.asset_location_id AS assetLocationId , at.transfered_quantity AS transferedQuantity , at.received_quantity AS receivedQuantity , at.note AS note ,at.received_user AS receivedUser ,
            at.created_user AS createdUser , at.asset_id AS assetId FROM `+appSettings.assets_db+`.asset_transfer at LEFT JOIN `+appSettings.masters_db+`.unitcodes u ON u.unit_code_id = at.unit_id LEFT JOIN `+appSettings.masters_db+`.unitcodes uf ON uf.unit_code_id = at.from_plant LEFT JOIN `+appSettings.masters_db+`.unitcodes ut ON ut.unit_code_id = at.to_plant LEFT JOIN `+appSettings.assets_db+`.assets a ON a.asset_id = at.asset_id LEFT JOIN `+appSettings.masters_db+`.items i ON i.item_id = a.assets_name LEFT JOIN `+appSettings.masters_db+`.item_sub_categories isc ON isc.item_sub_category_id = at.asset_category_id WHERE at.asset_transfer_id =`+req.assetTransferId+``
            let data = await manager.query(TransferQuery)
            if(data.length > 0){
                return new CommonResponse(true,1001,"transfers data retrieved successfully ", data);
            }
            else{
                return new CommonResponse(false,1010,"Something went wrong. ",);
            }
        }catch (error) {
            return error;
        }
    }

}